import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import Row from '../S80/components/common/Row';

export interface IPrimaryCloseControlProps {
  monitor?: string;
  isPrimary?: boolean;
  isSecondary?: boolean;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  top: 25px;
  width: 100%;
  height: 88%;
  margin-top: 5px;
  overflow-y: hidden;
  font-size: 14px;
`;
const RowContainer = styled(Row)<any>`
  margin-bottom: 2px;
`;
const LabelContainer = styled.div`
  width: 35%;
  padding-left: 10px;
  text-transform: uppercase;
`;
const ValueContainer = styled.div`
  color: white;
`;

export default function PrimaryCloseControl(props: IPrimaryCloseControlProps) {
  const { monitor = 'upper', isPrimary, isSecondary } = props;
  const hookedItems = useSelector((state: any) => state.executor.hookedItems);
  const activeMonitor = useSelector(
    (state: any) => state?.executor?.s80?.touchPanelVariables?.activeMonitor
  );

  const [hookedPoint, setHookedPoint] = useState<any>([]);
  useEffect(() => {
    if (activeMonitor === monitor && isPrimary && hookedItems.primary) {
      setHookedPoint([...hookedItems.primary]);
    }
    if (activeMonitor === monitor && isSecondary && hookedItems.secondary) {
      setHookedPoint([...hookedItems.secondary]);
    }
  }, [hookedItems]);
  return (
    <Container>
      {hookedPoint.map((hookProp: any, index: number) => {
        return Object.keys(hookProp).map((key: string) => {
          return (
            <RowContainer key={index}>
              <LabelContainer>{key}</LabelContainer>
              <ValueContainer> {hookProp[key]} </ValueContainer>
            </RowContainer>
          );
        });
      })}
    </Container>
  );
}
